import { createSelector } from 'reselect';
import _ from 'lodash';
import { pendingResponse } from '../fetchStatus';

export const additionalCrumbsResponseSelector = state => state.additionalCrumbs || pendingResponse;

export const additionalCrumbsSelector = createSelector([additionalCrumbsResponseSelector], additionalCrumbsResponse => additionalCrumbsResponse.data);

//export const carBrandNamesSelector = createSelector([additionalCrumbsSelector], additionalCrumbs => _.map(additionalCrumbs, 'marke'));
